import axios from "axios";
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {useMessageStore} from "@src/stores/messages";
import ChatSession from "@src/types/ChatSession";
import {db} from "@src/services/db";
import BotMessageService from "@src/services/botMessage";
import NotificationsService from "@src/services/notifications";

type BotMessageEventPayload = {
    message: any;
    tempId?: string | number | null;
};

async function ensureBotSessionExists(sessionId: number): Promise<ChatSession | null> {
    const local = await db.sessions.get(sessionId);
    if (local) return local as ChatSession;

    try {
        const response = await axios.get("/operator/v4/sync/bot-sessions", {
            withCredentials: true,
        });

        const sessions = response?.data?.data ?? [];
        const found = sessions.find((s: any) => Number(s.id) === Number(sessionId)) ?? null;

        if (!found) return null;

        await db.sessions.put({
            ...found,
            updated_at: found.updated_at ?? new Date().toISOString(),
        } as any);

        NotificationsService.notify(`Bot: nova mensagem de ${found.costumer.name}.`, false, true);

        return found as ChatSession;
    } catch (e) {
        console.error("❌ erro ao garantir sessão bot no IndexedDB", e);
        return null;
    }
}

export function NewBotMessageListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const messageStore = useMessageStore();

    const companyId = Number((auth.user as any).company_id);

    // @ts-ignore
    window.websockets.private(`company.${companyId}`)
        .listen(".NewBotMessageEvent", async (event: BotMessageEventPayload) => {
            try {
                const msg = event?.message;

                const sid = msg.session ? Number(msg.session.id) : Number(msg.chat_session_id);

                await ensureBotSessionExists(sid);
                await BotMessageService.updateSessionLastMessage(sid, msg);

                if (!sessionStore.selectedSession) {
                    return
                }

                const openedId = Number((sessionStore.selectedSession as any).id);

                if (openedId !== sid) {
                    return;
                }

                const exists = messageStore.botMessages.some(
                    (m: any) => Number(m.id) === Number(msg.id)
                );

                if (!exists) {
                    messageStore.botMessages.push(msg);
                }

                messageStore.botLastId = Math.max(
                    Number(messageStore.botLastId ?? 0),
                    Number(msg.id ?? 0)
                );

                await sessionStore.scrollDownGroup(true);
            } catch (e) {
                console.error("❌ erro no listener NewBotMessageEvent", e);
            }
        });
}